import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetProductDetailsRequestType,
  GetProductDetailsResponseType
} from '../../../services/PaymentServices/APIService/types';

import usePaymentServices from '../usePaymentServices';

interface UseGetProductDetailsInterface {
  getProductDetailsApi: UseMutateAsyncFunction<
    GetProductDetailsResponseType,
    Error,
    { productCode: string; requestObject: GetProductDetailsRequestType }
  >;
  error: string | null;
  status: MutationStatus;
}

const useGetProductDetails = (): UseGetProductDetailsInterface => {
  const { paymentServices } = usePaymentServices();

  const getProductDetails = ({
    productCode,
    requestObject
  }: {
    productCode: string;
    requestObject: GetProductDetailsRequestType;
  }) => {
    return paymentServices.getSelectedProductInfo({
      productCode,
      requestObject
    });
  };

  const { mutateAsync, error, status } = useMutation(getProductDetails, {
    mutationKey: ['getProductDetailsApi']
  });

  return {
    getProductDetailsApi: mutateAsync,
    error: error ? getAPIErrorMessage(error) : null,
    status
  };
};

export { useGetProductDetails };
